import {
  useCallback,
  useEffect,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Talk from 'talkjs';

import ChatManager from '../modules/chat/ChatManager';
import { IRootDispatch, RootState } from '../store/models';
import { ChatRoles } from '../modules/chat/chatTypes';
import { CHAT } from '../route-names';
import useCurrentChatSession from './useCurrentChatSession';
import { PublicProvider } from '../api/Providers';

const useGoToChatWithPro = (provider: Pick<PublicProvider, 'id' | 'name'>) => {
  const dispatch: IRootDispatch = useDispatch();

  const currentUser = useSelector((state: RootState) => state.user);
  const [selectedUser, setSelectedUser] = useState(null);
  const getChatSession = useCurrentChatSession(selectedUser, ChatRoles.Client);

  useEffect(() => {
    setSelectedUser(currentUser);
  }, [currentUser]);

  return useCallback(async () => {
    await getChatSession();
    const clientChatUser = ChatManager.chatUser;
    const proChatUser = new Talk.User({
      id: provider.id,
      name: provider.name,
      role: ChatRoles.Provider,
    });

    const chatId = await ChatManager.createOneOnOneConversation(
      proChatUser,
      clientChatUser,
    );

    await dispatch.route.go({
      route: CHAT,
      params: {
        chatId,
        requiredRole: ChatRoles.Client,
      },
    });
  }, [selectedUser]);
};

export default useGoToChatWithPro;
